import { Stack } from "@mui/material";
import { useMemo, useState } from "react";
import { useGridDataSourceWithRange } from "@entrilia/shared/components/grid/gridHooks";
import adminApi from "../../../../api/adminApi";
import useClientContext from "../../../../context/useClientContext";
import { FilterContextProvider } from "../../../common/filters/FilterContextProvider";
import FiltersPanel from "../../../common/filters/FiltersPanel";
import { getInitialFilterState } from "../../../common/filters/filterState";
import DataSubmissionsGrid from "./DataSubmissionsGrid";
import {
  allSubmissionsFilterDefinitions,
  getDataSubmissionsFilterPayload,
  selectOptionsResolver,
} from "./dataSubmissionsGridFilters";

const AllDataSubmissionsList = () => {
  const { clientCode } = useClientContext();

  const filterId = useMemo(() => `${clientCode}_data_submissions_filter_v1`, [clientCode]);

  const [filterState, setFilterState] = useState(() =>
    getInitialFilterState(filterId, allSubmissionsFilterDefinitions, [])
  );

  const filterPayload = useMemo(() => getDataSubmissionsFilterPayload(filterState), [filterState]);

  const { gridApiRef, dataSource, totalRows, isLoading, isRefreshing, refreshDataSource } = useGridDataSourceWithRange(
    adminApi.searchDataSubmissions,
    filterPayload
  );

  return (
    <FilterContextProvider
      filterState={filterState}
      setFilterState={setFilterState}
      getSelectOptionsForFilter={selectOptionsResolver}
    >
      <Stack spacing={2} sx={{ height: "100%" }}>
        <FiltersPanel
          recordCount={totalRows ?? 0}
          isLoading={isLoading}
          isRefreshing={isRefreshing}
          onRefresh={refreshDataSource}
        />

        <DataSubmissionsGrid apiRef={gridApiRef} dataSource={dataSource} filterId={filterId} lazyLoading />
      </Stack>
    </FilterContextProvider>
  );
};

export default AllDataSubmissionsList;
